export default __webpack_public_path__ + "static/media/aeps.073f83db.svg";